import { keyArgsForPagination, mergeForPagination } from "./modules/utils";

const yearGroupTypePolicy = {
  YearGroup: {
    fields: {
      students: {
        keyArgs: args => {
          if (args) {
            const filters = args["filters"];
            const keys = keyArgsForPagination(filters);
            return ["filters", keys];
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPagination({
              existing,
              incoming,
              readField,
              filters: args["filters"],
            });
          }
          return incoming;
        },
      },
    },
  },
};

export default yearGroupTypePolicy;
